
<app-gmao-spinner *ngIf="!installations"></app-gmao-spinner>

<!-- <button class="btn btn-outline-info">Nouveau <i class="material-icons">add_circle_outline</i></button> -->
<ng-container *ngIf="installations">
    <h2>Installations</h2>

<mat-tab-group mat-align-tabs="center" *ngIf="!restricted">
    <mat-tab label="Projet"> <app-installations-projects [installations]="installations"></app-installations-projects>  </mat-tab>
    <mat-tab label="Installées"> <app-installations-installed [installations]="installations"></app-installations-installed>  </mat-tab>
    <mat-tab label="En service"> <app-installations-service [installations]="installations"></app-installations-service>  </mat-tab>
    <mat-tab label="Arrêtées"> <app-installations-stopped [installations]="installations"></app-installations-stopped>  </mat-tab>
    <mat-tab label="Désinstallées"> <app-installations-uninstalled [installations]="installations"></app-installations-uninstalled>  </mat-tab>
    <!-- <mat-tab label="Personnaliser"> <app-installations-custom></app-installations-custom>  </mat-tab> -->
</mat-tab-group>

<mat-tab-group mat-align-tabs="center" *ngIf="restricted">
    <mat-tab label="En service"> <app-installations-service [installations]="installations"></app-installations-service>  </mat-tab>
</mat-tab-group>

</ng-container>


<!--
    Au chargement, la page affiche la liste des daps en service, classés par ordre alphabétique
    Un clic sur une colonne entraine un classement par cette colonne
    Onglet Installées sur le même principe
    Onglet Arrêtées de même sauf que la colonne "mise en service" devient "Date d'arrêt"
    Onglet Désinstallées idem, colonne "Date de désinstallation"
    Onglet Personnaliser voir si vraiment utilie car les champs à personnaliser ne sont pas à jour
-->